import { TypePolicy } from '@apollo/client';

export const trackTypePolicy: TypePolicy = {
  fields: {
    blip: {
      merge( existing, incoming ) {
        // This prevents track.blips returned from CatalogSearchQuery (which have no blip data) from replacing StationDetailsV2Query track.blips with null data.
        // Happens when a user gets search results from the Station Edit CatalogSearch sidebar that include a Track that's already in the station.
        if ( !incoming ) {
          return existing;
        } else {
          return incoming;
        }
      },
    },
  },
};
